import { toast } from 'react-toastify';

import { isArray } from 'lodash';
import moment from 'moment';
import qs from 'querystring';
import { takeLatest, call, put, all } from 'redux-saga/effects';

import { t } from '~/helpers';
import api from '~/services/api';
import history from '~/services/history';

import {
  successInRequest,
  failedRequest,
  successRemove,
  successRequest,
} from './actions';

export function* requestOperacaoRecebimentos({ payload }) {
  try {
    const { params } = payload;
    const response = yield call(api.get, 'descargas', {
      params,
      paramsSerializer: (param) => qs.stringify(param),
    });
    const { items, page, pageSize, totalCount, totalPages } = response.data;

    yield put(successInRequest(items, page, pageSize, totalCount, totalPages));
  } catch (erros) {
    yield put(failedRequest());
    if (isArray(erros)) erros.map((e) => toast.error(e));
    else toast.error(erros);
  }
}

export function* deleteOperacaoRecebimento({ payload }) {
  try {
    const { idoperacaorecebimento, params } = payload;

    yield call(api.delete, `descargas/${idoperacaorecebimento}`);
    yield put(successRemove({ ...params, pesquisalista: true }));

    toast.success(t('s.geral.sucessoexclusao'));
  } catch (erros) {
    yield put(failedRequest());
    if (isArray(erros)) erros.map((e) => toast.error(e));
    else toast.error(erros);
  }
}

export function* store({ payload }) {
  try {
    const { operacaorecebimento, params } = payload;

    yield call(api.post, 'descargas', operacaorecebimento);
    yield put(successRemove({ ...params, pesquisalista: true }));

    toast.success(t('s.geral.sucessoinclusao'));
    history.push('/operacaorecebimento');
  } catch (erros) {
    yield put(failedRequest());
    if (isArray(erros)) erros.map((e) => toast.error(e));
    else toast.error(erros);
  }
}

export function* find({ payload }) {
  try {
    const { idoperacaorecebimento } = payload;

    const { data } = yield call(api.get, `descargas/${idoperacaorecebimento}`);

    yield put(successRequest(data));
  } catch (erros) {
    yield put(failedRequest());
    if (isArray(erros)) erros.map((e) => toast.error(e));
    else toast.error(erros);
  }
}

export function* update({ payload }) {
  try {
    const { operacaorecebimentos, params } = payload;

    yield call(api.put, 'descargas', operacaorecebimentos);
    yield put(successRemove({ ...params, pesquisalista: true }));

    toast.success(t('s.geral.sucessoalteracao'));
    history.push('/operacaorecebimento');
  } catch (erros) {
    yield put(failedRequest());
    if (isArray(erros)) erros.map((e) => toast.error(e));
    else toast.error(erros);
  }
}

export function* applyedFilters({ payload }) {
  try {
    const { params } = payload;

    const response = yield call(api.get, 'descargas', {
      params,
      paramsSerializer: (param) => qs.stringify(param),
    });

    const { items, page, pageSize, totalCount, totalPages } = response.data;

    yield put(successInRequest(items, page, pageSize, totalCount, totalPages));
  } catch (erros) {
    yield put(failedRequest());
    if (isArray(erros)) erros.map((e) => toast.error(e));
    else toast.error(erros);
  }
}

export default all([
  takeLatest(
    '@operacaorecebimento/OPERACAORECEBIMENTOS_IN_REQUEST',
    requestOperacaoRecebimentos
  ),
  takeLatest(
    '@operacaorecebimento/DELETE_OPERACAORECEBIMENTO',
    deleteOperacaoRecebimento
  ),
  takeLatest(
    '@operacaorecebimento/SUCCESS_REMOVE',
    requestOperacaoRecebimentos
  ),
  takeLatest('@operacaorecebimento/STORE_OPERACAORECEBIMENTO', store),
  takeLatest('@operacaorecebimento/FIND_OPERACAORECEBIMENTO', find),
  takeLatest('@operacaorecebimento/UPDATE_OPERACAORECEBIMENTO', update),
  takeLatest('@operacaorecebimento/RECORD_FILTERING', applyedFilters),
]);
